import { createPinia } from 'pinia'
import { createApp } from 'vue'

import 'flag-icons/css/flag-icons.min.css'
// DS main needs to be imported AFTER any 3rd party libraries
import '@tix/ds/styles/main.css'
// app main needs to be imported AFTER design-system main
import '@/styles/main.css'

import { installLanguage } from '@tix/language'

import { getEnv } from '@/helpers/environment'

import { errorTracker } from '@/services/errorTracking'

import { useIdentityStore } from '@/stores/identity'

import App from '@/App.vue'
import autofocus from '@/directives/autofocus'
import sanitize from '@/directives/sanitizeHtml'
import router from '@/router'

getEnv()

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(installLanguage(getEnv().language_strings, getEnv().seller?.meta))

app.directive('autofocus', autofocus)
app.directive('shtml', sanitize)

// Vue error handler - catches errors in component rendering, watchers, lifecycle hooks
app.config.errorHandler = (error, instance, info) => {
  const err = error instanceof Error ? error : new Error(`Vue error: ${info}`, { cause: error })
  errorTracker.track(err, {
    component: instance?.$options?.name,
    vueInfo: info,
  })
}

// Unhandled promise rejections
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason instanceof Error) {
    errorTracker.track(event.reason)
  } else {
    errorTracker.track('Unhandled promise rejection', { cause: event.reason })
  }
})

const identityStore = useIdentityStore()
identityStore.load()

app.mount('#app')
